import { useTranslation } from 'next-i18next'

import { PanelTab, PanelView } from '~/panels/components/PanelWrapper/PanelWrapper.types'

import PanelTabItem from './PanelTabItem'

export default function PanelTabs<T extends PanelView>({
  disabledTabs,
  tabs,
  view,
}: {
  disabledTabs?: T[]
  tabs: Array<PanelTab<T>>
  view?: T
}): React.ReactElement {
  const { t } = useTranslation('panels')

  return (
    /**
     * Below `lg` the strip scrolls sideways rather than squeezing every tab in — which is how the
     * school edition's provisioning tabs became unreachable on a phone. `pb-0.5` absorbs the 2px
     * the active underline hangs below the list, which would otherwise add a vertical scrollbar.
     */
    <div className="pb-0.5 overflow-x-auto lg:pb-0 lg:overflow-x-visible">
      <ul className="w-max min-w-full lg:min-w-0 space-x-4 lg:space-x-8 flex border-b-2 border-black/10">
        {tabs.map(({ href, icon, type }) => (
          <PanelTabItem
            href={href}
            icon={icon}
            isActive={view === type}
            isDisabled={Boolean(disabledTabs?.includes(type))}
            key={type}
            label={t(`tab.${type}`)}
          />
        ))}
      </ul>
    </div>
  )
}
